import { fromJS } from 'immutable';

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from '../actions/actionTypes';

const initialState = fromJS({
  notifications: [],
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      return state.update('notifications', notifications =>
        notifications.push(fromJS(action.notification)),
      );
    }
    case REMOVE_NOTIFICATION: {
      const notifications = state.get('notifications');
      const filteredNotifications = notifications.filter(
        notification => notification.key !== action.key,
      );
      return state.set('notifications', filteredNotifications);
    }
    default:
      return state;
  }
};

export default reducer;
